// Needed to fix dialog opening closing issue on older iOS devices
export const MdDialogFix = () => {
  const elements: any = document.getElementsByClassName('cdk-overlay-container');
  elements[0].style.cssText += ';-webkit-transform: rotateZ(0deg) !important';
  elements[0].style.cssText += ';-webkit-transform: none !important';
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/md-dialog-fix.ts